import React from 'react';
import { Calendar, Mail, Phone } from 'lucide-react';
import ProfileAvatar from '../shared/ProfileAvatar';

const joinedOn = (date) => new Date(date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

const Detail = ({ icon: Icon, children }) => (
  <li className="tw-flex tw-min-w-0 tw-items-center tw-gap-2.5 tw-text-xs tw-text-content-muted">
    <Icon size={14} aria-hidden="true" className="tw-shrink-0 tw-text-content-subtle" />
    <span className="tw-min-w-0 tw-truncate">{children}</span>
  </li>
);

/** The rail's first card, from a laptop up. Below that the banner carries the profile. */
const ProfileCard = ({ profile }) => (
  <div className="tw-hidden tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-line tw-bg-surface-raised tw-shadow-card page-lg:tw-block">
    <div className="tw-flex tw-flex-col tw-items-center tw-bg-gradient-to-b tw-from-primary-solid tw-to-[color-mix(in_srgb,hsl(var(--primary-solid))_82%,black)] tw-px-[18px] tw-pb-[18px] tw-pt-[22px] tw-text-center tw-text-primary-solid-fg">
      <ProfileAvatar name={profile.name} src={profile.avatarUrl} className="tw-mb-2.5 tw-h-[76px] tw-w-[76px]" />
      <div className="tw-max-w-full tw-text-base tw-font-medium tw-leading-tight">{profile.name}</div>
      {profile.role && <div className="tw-mt-1.5 tw-text-xs tw-leading-snug tw-text-primary-solid-fg/85">{profile.role}</div>}
      {profile.active && (
        <span className="tw-mt-2 tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-primary-solid-fg/15 tw-px-2.5 tw-py-0.5 tw-text-[0.6875rem] tw-font-medium">
          <span className="tw-h-[7px] tw-w-[7px] tw-rounded-full tw-bg-success" aria-hidden="true" />
          Active
        </span>
      )}
    </div>
    <ul className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-2.5 tw-px-[18px] tw-py-3.5">
      {profile.email && <Detail icon={Mail}>{profile.email}</Detail>}
      {profile.phone && <Detail icon={Phone}>{profile.phone}</Detail>}
      {profile.joinedAt && <Detail icon={Calendar}>Joined {joinedOn(profile.joinedAt)}</Detail>}
    </ul>
  </div>
);

export default ProfileCard;
